import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'taunt',
    apply: ({ state, source, params }) => {
        const duration = params.duration ?? 3;
        getRuntimes(state, source.side)[source.slot].statuses.push({
            id: `taunt_${state.tick}_${source.slot}`,
            kind: 'taunt',
            remainingTicks: duration,
            params: {},
            source: { side: source.side, slot: source.slot }
        });
        state.events.push({ t: state.tick, kind: 'status_apply', side: source.side, slot: source.slot, status: 'taunt', duration });
    }
});
